import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

import { InternalCustomer, InternalCustomerOption } from 'types/GlobalCustomer'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

export const selectCustomersById = (state: ApplicationState) =>
  state.InternalCustomerStore.data

export const selectCustomersFetchStatus = (state: ApplicationState) =>
  state.InternalCustomerStore.fetchStatus

/** Our customers, by name. */
export const selectCustomers = createSelector(
  [selectCustomersById],
  (data): InternalCustomer[] =>
    Object.values(data).sort((a, b) => sortAlphabeticalAsc(a.name, b.name))
)

/**
 * Our customers as picker options, by name. Sorted here so every picker shows
 * them in the same order.
 */
export const selectCustomerOptions = createSelector(
  [selectCustomers],
  (customers): InternalCustomerOption[] =>
    customers.map((customer) => ({ id: customer.id, title: customer.name }))
)
